import { render, staticRenderFns } from "./footerPhone.vue?vue&type=template&id=82d94c12&scoped=true&"
import script from "./footerPhone.vue?vue&type=script&lang=js&"
export * from "./footerPhone.vue?vue&type=script&lang=js&"
import style0 from "./footerPhone.vue?vue&type=style&index=0&id=82d94c12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d94c12",
  null
  
)

export default component.exports